// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Rectangle } from '@shared/commons/Geometry';
import { QuickTableColumn } from '../QuickTable/QuickTableColumn';
import { Control, ControlEvents } from '../Control';
import { KeyCode, KeyEventProcessor } from '@shared/commons/KeyEventProcessor';
import TerceraLookupTemplate from '@front/templates/TerceraLookupTemplate.html';
import { ContainerControl } from '../ContainerControl';
import { QuickTableCell } from '../QuickTable/QuickTableCell';
import { QuickTableRactive } from '../QuickTable/QuickTableRactive';
import { QuickTableRow } from '../QuickTable/QuickTableRow';
import { TerceraPanel } from '../TerceraPanel';
import { TextBoxEvents } from '../TerceraTextBox';
import { popupErrorHandler } from '@shared/utils/AppHandlers';
import { CustomEvent } from '@shared/utils/CustomEvents';
import { ThemeManager } from '../../misc/ThemeManager';
import $ from 'jquery';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
import { ControlsUtils } from '../../UtilsClasses/ControlsUtils';
export class TerceraLookup extends ContainerControl {
    constructor() {
        super(...arguments);
        this.button = null;
        this.textBox = null;
        this.items = [];
        this.autoCompliteQuickTable = null;
        this.currentNameFilter = null;
        this.asyncPopulateInterval = null;
        this.fromDropDownFormOrAutoComplite = false;
        this.onChangeValue = null;
        this.callBack = null;
        this.isMultiSelect = false;
        this.selectedItemIndex = -1;
        this.selectedItem = null;
        this.needCloseTableAfterClick = true;
        this.AUTOCOMPLETE_MAX_ROWS_COUNT = 10;
    }
    getType() {
        return 'TerceraLookup';
    }
    oninit() {
        super.oninit();
        this.onChangeValue = new CustomEvent();
    }
    completeBlock() {
        this.onChangeValue = new CustomEvent(); // Need for QuickTableAccountLookup and QuickTableInstrumentLookup
        this.onChangeValue.Subscribe(this.runCallback.bind(this), this);
        this.on('lookupBtnClick', this.showForm);
        this.observe('haveError', function (newValue) {
            void this.set({ errorStyle: newValue ? 'error' : '' });
        });
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    oncomplete() {
        super.oncomplete();
        this.createAutoCompleteTable();
        // TODO. oncomplete is still being executed after dispose/teardown.
        // Reproduced when PropertySetupScreen is called from chart.
        // It might be due to a fast switching of pages.
        // PanelSettingsScreen.selectPage() method.
        if (isNullOrUndefined(this.Controls.lookupTB))
            return;
        this.textBox = this.Controls.lookupTB;
        this.textBox.on(TextBoxEvents.TextChanged, this.onTextChange.bind(this));
        this.textBox.on('keyDown', this.onKeyDown.bind(this));
        this.textBox.on('mouseWheel', this.onMouseWheel.bind(this));
        this.on(ControlEvents.LostFocus, this.onLostFocus.bind(this));
        this.setSelectValue(this.get('selectedItem') || this.items[0], /* suppressEvents */ true);
        this.observe('selectedItem', this.setSelectValue, { init: false });
        ThemeManager.onThemeChange.Subscribe(this.themeChange, this);
        this.themeChange();
        this.completeBlock();
    }
    // Because of lookup control caching in fx board panel template.
    onunrender() {
        if (super.onunrender) {
            super.onunrender();
        }
        const qt = this.autoCompliteQuickTable;
        if (!isNullOrUndefined(qt))
            qt.set('visible', false);
    }
    dispose() {
        this.stopQTUpdate();
        ThemeManager.onThemeChange.UnSubscribe(this.themeChange, this);
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        this.removeAutoCompleteTable();
        super.dispose();
    }
    onteardown() {
        this.lookupErrorHideShow(false);
        this.dispose();
        super.onteardown();
    }
    localize() {
        void this.set('btnTooltip', this.getButtonTooltip());
    }
    getButtonTooltip() {
        return '';
    }
    showForm() {
        void this.set('isFormShowed', true);
    }
    closeForm() {
        void this.set('isFormShowed', false);
    }
    setItems(newItems) {
        if (isNullOrUndefined(newItems)) {
            return;
        }
        const keys = Object.keys(newItems);
        const items = newItems;
        let j;
        const len = keys.length;
        this.items = [];
        for (j = 0; j < len; j++) {
            this.items.push(items[keys[j]]);
        }
    }
    onBtnClick() {
        return false;
    }
    onTextChange(context, value) {
        if (this.fromDropDownFormOrAutoComplite) {
            this.fromDropDownFormOrAutoComplite = false;
            return;
        }
        // if (value === '')
        // {
        //    this.currentNameFilter = null;
        //    this.populateAutoCompliteAsync();
        // }
        // else
        // {
        this.currentNameFilter = value.toLowerCase();
        this.populateAutoCompliteAsync();
        // }
    }
    populateAutoCompliteAsync() {
        clearTimeout(this.asyncPopulateInterval);
        this.asyncPopulateInterval = null;
        this.asyncPopulateInterval = setTimeout(this.populateAutoComplite.bind(this), 300);
    }
    populateAutoComplite() {
        const qTable = this.autoCompliteQuickTable;
        qTable.quickTable.ClearRows();
        if (this.currentNameFilter !== '') {
            this.fillAutoCompliteTableByItems();
        }
        else {
            qTable.set({
                visible: false
            });
            this.lookupErrorHideShow(false);
            return;
        }
        const quickTable = qTable.quickTable;
        const rowHeight = quickTable.rowHeight;
        const rowsCount = quickTable.visibleRowCount(); // rowsArray.length;
        let visibleRowsCount = this.AUTOCOMPLETE_MAX_ROWS_COUNT;
        if (rowsCount < visibleRowsCount) {
            visibleRowsCount = rowsCount;
        }
        if (rowsCount > 0) {
            qTable.set({
                visible: true,
                height: rowHeight * visibleRowsCount + 2
            });
            this.lookupErrorHideShow(false);
        }
        else {
            qTable.set({
                visible: false
            });
            this.lookupErrorHideShow(true);
        }
    }
    fillAutoCompliteTableByItems() {
        const qTable = this.autoCompliteQuickTable;
        let findStr = '';
        if (this.currentNameFilter !== null) {
            findStr = this.currentNameFilter.toLowerCase();
        }
        const items = this.items;
        const len = items.length;
        // const qTableWidth = this.get('width');
        for (let j = 0; j < len; j++) {
            const curItem = items[j];
            const curItemStr = curItem.toString(true);
            if (this.currentNameFilter !== null) {
                const curItemFindStr = curItemStr.toLowerCase();
                if (curItemFindStr.indexOf(findStr) === -1) {
                    continue;
                }
            }
            const r = new QuickTableRow();
            r.id = j;
            const cell = new QuickTableCell();
            cell.value = curItem;
            cell.formattedValue = curItemStr;
            cell.textPattern = this.currentNameFilter;
            r.cells.push(cell);
            qTable.quickTable.AddRow(r);
            // qTableWidth = Math.max(qTableWidth, ControlsUtils.GetTextWidth(curItemStr, qTable.quickTable.HeaderFont));
        }
        // qTable.set('width', qTableWidth);
        qTable.set('width', 400);
    }
    onAutoCompliteSelectionChanged(fromMouseClick) {
        if (fromMouseClick) {
            this.onAutoCompliteSelectRow(this.autoCompliteQuickTable);
        }
    }
    onAutoCompliteSelectRow(qTable) {
        const selectRowId = qTable.quickTable.selectedRowIds[0];
        const defaultRow = qTable.quickTable.rowsArray[0];
        if (isNullOrUndefined(selectRowId)) {
            this.setSelectValue(this.getTypingLookupValueForSet(this.textBox.get('text'), defaultRow));
        }
        else {
            const selectRow = qTable.quickTable.rows[selectRowId];
            if (isNullOrUndefined(selectRow)) {
                this.setSelectValue(this.getTypingLookupValueForSet(this.textBox.get('text'), defaultRow));
            }
            else {
                this.setSelectValue(selectRow.cells[0].value);
            }
        }
        if (this.needCloseTableAfterClick) {
            void qTable.set({ visible: false });
            qTable.quickTable.selectedRowIds = [];
            delete qTable.quickTable.lastSelectedRowId;
        }
    }
    getTypingLookupValueForSet(textValueIndificator, defaultRow) {
        return null;
    }
    dropDownFormCallBack(result) {
        this.setSelectValue(result);
    }
    onLostFocus() {
        if (this.get('selectedItem') !== this.selectedItem) {
            this.setSelectValue(this.selectedItem);
        }
        this.lookupErrorHideShow(false);
    }
    onKeyDown(event) {
        if (!this.get('enabled') || !this.get('focused')) {
            return true;
        }
        this.lastKeyCode = event.original.keyCode;
        const keyCode = event.original.keyCode;
        if (keyCode !== KeyCode.UP &&
            keyCode !== KeyCode.DOWN &&
            keyCode !== KeyCode.ENTER &&
            keyCode !== KeyCode.ESC) {
            return true;
        }
        const autoCompliteQuickTable = this.autoCompliteQuickTable;
        if (autoCompliteQuickTable.get('visible')) {
            // HACK.
            if (keyCode === KeyCode.ENTER) {
                this.onAutoCompliteSelectRow(autoCompliteQuickTable);
                this.textBox.selectAll();
            }
            else if (keyCode === KeyCode.ESC) {
                this.onLostFocus();
            }
            else {
                autoCompliteQuickTable.quickTable.trySelectUpDown(keyCode, false);
            }
        }
        else if (keyCode === KeyCode.ESC) {
            return;
        }
        else if (keyCode !== KeyCode.ENTER) {
            this.moveToItem(keyCode === KeyCode.DOWN);
        }
        else if (keyCode === KeyCode.ENTER) {
            this.onAutoCompliteSelectRow(autoCompliteQuickTable);
            this.textBox.selectAll();
        }
        this.lastKeyCode = -1;
        return false;
    }
    // If lookup's table is focused;
    onAutoCompleteGlobalKeyDownHandled() {
        if (KeyEventProcessor.currentButton === KeyCode.ENTER) {
            this.onAutoCompliteSelectRow(this.autoCompliteQuickTable);
        }
    }
    onMouseWheel(context) {
        if (!this.get('enabled') || !this.get('focused') || this.autoCompliteQuickTable.get('visible')) {
            return true;
        }
        this.moveToItem(context.event.deltaY < 0);
        return false;
    }
    moveToItem(next) {
        const newIndex = this.selectedItemIndex + (next ? 1 : -1);
        if (newIndex >= 0 && newIndex < this.items.length) {
            this.selectedItemIndex = newIndex;
            this.setSelectValue(this.items[newIndex]);
            this.textBox.selectAll();
        }
    }
    // TODO. Optimize way of finding selected index.
    setSelectValue(newSelectedItem, suppressEvents) {
        var _a;
        if (isNullOrUndefined(newSelectedItem)) {
            return;
        }
        const newText = newSelectedItem.toString(true);
        this.setLookUpText(newText);
        if (this.selectedItem === newSelectedItem) {
            return;
        }
        this.selectedItem = newSelectedItem;
        // For template data binding.
        void this.set('selectedItem', newSelectedItem);
        if (isNullOrUndefined(suppressEvents)) {
            (_a = this.onChangeValue) === null || _a === void 0 ? void 0 : _a.Raise(newSelectedItem);
            this.fire(TerceraLookupEvents.SelectedItemChanged, newSelectedItem);
        }
        this.updateSelectedItemIndex(newSelectedItem);
    }
    setLookUpText(newText) {
        this.fromDropDownFormOrAutoComplite = true;
        if (!isNullOrUndefined(this.textBox)) {
            this.textBox.set('text', newText).then(function () {
                this.fromDropDownFormOrAutoComplite = false;
            }.bind(this));
        }
        void this.set('labelText', newText);
    }
    updateSelectedItemIndex(newSelectedItem) {
        // Index of selected item has been found already.
        if (newSelectedItem === this.items[this.selectedItemIndex]) {
            return;
        }
        for (let i = 0; i < this.items.length; i++) {
            if (this.items[i] === newSelectedItem) {
                this.selectedItemIndex = i;
                break;
            }
        }
    }
    getX() {
        const offset = $(this.find('*')).offset();
        const posX = offset.left - $(window).scrollLeft();
        return posX;
    }
    getY(isTopCorner = true) {
        const element = this.find('*');
        const corner = isTopCorner ? 0 : element.offsetHeight;
        const offset = $(element).offset();
        const posY = offset.top - $(window).scrollTop() + corner;
        return posY;
    }
    runCallback(acc) {
        if (!isNullOrUndefined(this.callBack)) {
            this.callBack.call(this, acc);
        }
    }
    correctQTPopupLocation() {
        const qt = this.autoCompliteQuickTable;
        if (isNullOrUndefined(qt === null || qt === void 0 ? void 0 : qt.quickTable)) {
            return;
        }
        const quickTable = qt.quickTable;
        const rowN = Math.min(quickTable.visibleRowCount(), this.AUTOCOMPLETE_MAX_ROWS_COUNT);
        const p = ControlsUtils.CorrectPopupLocation(new Rectangle(this.getX(), this.getY() + 32, qt.get('width'), quickTable.rowHeight * rowN));
        qt.setLocation(p.newX, p.newY);
    }
    onQTVisibilityChanged(visible) {
        if (visible) {
            this.correctQTPopupLocation();
            this.startQTUpdate();
        }
        else
            this.stopQTUpdate();
    }
    startQTUpdate() {
        const qt = this.autoCompliteQuickTable;
        if (!isNullOrUndefined(qt)) {
            qt.GlobalKeyDownHandled.Subscribe(this.onAutoCompleteGlobalKeyDownHandled, this);
            qt.quickTable.OnSelectionChanged.Subscribe(this.onAutoCompliteSelectionChanged, this);
        }
        Control.Ticker.Subscribe(this.tick, this);
    }
    stopQTUpdate() {
        clearTimeout(this.asyncPopulateInterval);
        this.asyncPopulateInterval = null;
        const qt = this.autoCompliteQuickTable;
        if (!isNullOrUndefined(qt)) {
            qt.GlobalKeyDownHandled.UnSubscribe(this.onAutoCompleteGlobalKeyDownHandled, this);
            qt.quickTable.OnSelectionChanged.UnSubscribe(this.onAutoCompliteSelectionChanged, this);
        }
        Control.Ticker.UnSubscribe(this.tick, this);
    }
    tick() {
        this.autoCompliteQuickTable.quickTable.Draw();
    }
    themeChange() {
        this.autoCompliteQuickTable.themeChange();
        const quickTable = this.autoCompliteQuickTable.quickTable;
        quickTable.selectedBackColor = ThemeManager.colors.autocompleteQuickTreeNodeBackgroundSelected;
        quickTable.selectedHoveredBackColor = ThemeManager.colors.selectedAndHoveredRowBackColor;
        quickTable.hoveredBackColor = ThemeManager.colors.quickTreeNodeBackgroundHovered;
        quickTable.selectedForeColor = ThemeManager.colors.quickTreeNodeForegroundSelected;
    }
    createAutoCompleteTable() {
        const autoCompleteTablesContainer = TerceraLookup.getAutoCompleteTablesContainer();
        const qTable = new QuickTableRactive();
        void qTable.set('isAttached', false);
        autoCompleteTablesContainer.addControl(qTable);
        const quickTable = qTable.quickTable;
        void qTable.set({
            width: 200,
            height: quickTable.rowHeight * this.AUTOCOMPLETE_MAX_ROWS_COUNT,
            visible: false,
            additionalClass: 'quickTableOuter-position-absolute',
            autocompleteTable: true
        });
        quickTable.columns.push(new QuickTableColumn());
        quickTable.UpdateSortedColumns();
        qTable.setShowColumnHeaders(false);
        qTable.observe('visible', this.onQTVisibilityChanged.bind(this));
        this.autoCompliteQuickTable = qTable;
    }
    removeAutoCompleteTable() {
        const autoCompleteTablesContainer = TerceraLookup.getAutoCompleteTablesContainer();
        autoCompleteTablesContainer.removeControl(this.autoCompliteQuickTable);
    }
    static getAutoCompleteTablesContainer() {
        if (!isNullOrUndefined(TerceraLookup.autoCompleteTablesContainer)) {
            return TerceraLookup.autoCompleteTablesContainer;
        }
        TerceraLookup.autoCompleteTablesContainer = new TerceraPanel({
            el: '#autoCompleteTablesContainer'
        });
        return TerceraLookup.autoCompleteTablesContainer;
    }
    lookupErrorHideShow(isShow) {
        if (isShow) {
            void this.set({ haveError: true });
        }
        else {
            popupErrorHandler.Hide(this);
            void this.set({ haveError: false });
        }
    }
    showPopupError(errorTextForNumeric, headerText) {
        if (!this.get('enabled') || !this.get('focused') || !isValidString(errorTextForNumeric)) {
            return;
        }
        popupErrorHandler.Show(this, errorTextForNumeric, headerText);
    }
    getAbsoluteRectangle() {
        return ControlsUtils.getAbsoluteRectangleForElement(this);
    }
}
export var TerceraLookupEvents;
(function (TerceraLookupEvents) {
    TerceraLookupEvents["SelectedItemChanged"] = "SelectedItemChanged";
})(TerceraLookupEvents || (TerceraLookupEvents = {}));
ContainerControl.extendWith(TerceraLookup, {
    template: TerceraLookupTemplate,
    data: function () {
        return {
            btnClass: 'js-lookup-show',
            btnName: 'instrumentLookup',
            cssClass: 'js-tercera-lookup',
            errorStyle: '',
            selectedItem: null,
            labelText: '',
            haveError: false,
            isReadOnly: false,
            btnTooltip: '',
            isInstrumentLookup: false,
            isPosAbsolute: false,
            tbIsVisible: true,
            showDisabledToolTip: false,
            isFormShowed: false
        };
    }
});
